import { render, staticRenderFns } from "./employee-compensation.vue?vue&type=template&id=71469098&scoped=true&"
import script from "./employee-compensation.vue?vue&type=script&lang=js&"
export * from "./employee-compensation.vue?vue&type=script&lang=js&"
import style0 from "./employee-compensation.vue?vue&type=style&index=0&id=71469098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71469098",
  null
  
)

export default component.exports